import mod from "-!./paperEdit.js?vue&type=script&lang=js&"; export default mod; export * from "-!./paperEdit.js?vue&type=script&lang=js&"